module.exports = __webpack_public_path__ + "static/media/checkedCheckbox.ae2e8970.svg";